export default (obj)=>({
    type: '',
    // MIGRATED_FROM_OLD_CODE
    bis_form_open: false,
    bis_variant: '',
    notifyText: '',
    product: obj.product ? obj.product : null,
    drawer: null,
    drawerWrapper: null,
    openDrawer: false,
    drawerState: 'init',
    drawerButtonText: 'Select option',
    drawerButtonDisable: false,
    drawerOpenNotify: false,
    isClosing: false,
    variant: null,
    addToCardLoading: false,
    init() {
        if(!this.product) {
            return null;
        }
    },

    getNotifyText() {
        const variant = this.getCurrentVariant(this.bis_variant);

        let title = variant?.title;

        title = title === 'Default Title' ? '' : ` - ${title}`;

        this.notifyText =  variant ? `${this.product.title} ${title}` : '';
    },

    getCurrentVariant(variantID){
        return this.product.variants.find(variant => variant.id === variantID);
    },

    openMobileDrawer() {
          this.openDrawer = true;
    },

    closeMobileDrawer() {
        window.dispatchEvent(new Event('close-drawer'));
        this.removeDrawerEventListener();
    },

    setDrawerListeners() {

        this.drawer = this.$el;

        this.drawerWrapper = this.drawer.querySelector('.product-card__mobile-drawer-touch');
        const bottomSheetHandle = this.drawer.querySelector('.product-card__mobile-drawer-header');


        if (bottomSheetHandle && this.drawerWrapper) {

            this.onMouseDown = this.onMouseDown.bind(this);
            this.onMouseMove = this.onMouseMove.bind(this);
            this.onMouseUp = this.onMouseUp.bind(this);

            this.onTouchStart = this.onTouchStart.bind(this);
            this.onTouchMove = this.onTouchMove.bind(this);
            this.onTouchEnd = this.onTouchEnd.bind(this);

            bottomSheetHandle.addEventListener('mousedown', this.onMouseDown);
            document.addEventListener('mousemove', this.onMouseMove);
            document.addEventListener('mouseup', this.onMouseUp);

            bottomSheetHandle.addEventListener('touchstart', this.onTouchStart);
            document.addEventListener('touchmove', this.onTouchMove);
            document.addEventListener('touchend', this.onTouchEnd);
        }
    },

    onMouseDown(event) {
        this.startDrag(event, event.clientY);
    },

    onMouseMove(event) {
        this.drag(event, event.clientY);
    },

    onMouseUp(event) {
        this.endDrag(event, event.clientY);
    },

    onTouchStart(event) {
        this.startDrag(event, event.touches[0].clientY);
    },

    onTouchMove(event) {
        this.drag(event, event.touches[0].clientY);
    },

    onTouchEnd(event) {
        this.endDrag(event, event.changedTouches[0].clientY);
    },


    startDrag(event, clientY) {
        this.isDragging = true;
        this.startY = clientY;
        const style = window.getComputedStyle(this.drawer);
        const matrix = new DOMMatrixReadOnly(style.transform);
        this.initialTranslateY = matrix.m42;
        this.drawer.classList.add('is-dragging');
    },

    drag(event, clientY) {

        if (!this.isDragging) {
            return null;
        }

        const deltaY = clientY - this.startY;
        const newTranslateY = Math.max(this.initialTranslateY + deltaY, 0);
        this.drawerWrapper.style.transform = `translateY(${newTranslateY}px)`;

    },

    endDrag(event, clientY) {

        if (!this.isDragging) {
            return null;
        }

        const deltaY = clientY - this.startY;

        this.drawer.classList.remove('is-dragging');
        this.drawerWrapper.style.transform = '';

        if (deltaY > 80) {
            this.closeMobileDrawer();
            this.removeDrawerEventListener();
        }


        this.isDragging = false;
    },

    removeDrawerEventListener() {
        document.removeEventListener('mousemove', this.onMouseMove);
        document.removeEventListener('mouseup', this.onMouseUp);
        document.removeEventListener('touchmove', this.onTouchMove);
        document.removeEventListener('touchend', this.onTouchEnd);
    },

    addActiveSubscription() {

        const allSubscriptions = document.querySelectorAll('.product-card__subscription-item');

        allSubscriptions.forEach(subscription => {
            subscription.classList.remove('active');
        });

        this.$el.classList.add('active');
    },

    addActiveSizes() {
        const allSubscriptions = document.querySelectorAll('.product-card__variant');

        allSubscriptions.forEach(subscription => {
            subscription.classList.remove('active');
        });

        this.$el.classList.add('active');
    },

    changeDrawerSubscription(obj) {

        this.drawerState = obj.type;

        switch (obj.type) {
            case 'add':
                this.drawerButtonText = 'add to bag';
                this.variant = obj.variantId;
                break
            case 'select':
                this.drawerButtonText = 'Select options';
                break
            case 'notify':
                this.drawerButtonText = 'out of stock - notify me';
        }
    },

    drawerAddButton() {
        if (this.drawerState === 'add') {
            this.addToCart(this.variant);
        } else if (this.drawerState === 'notify') {
            this.drawerOpenNotify = true;
        }
    },

    addToCart(variantID, qty = 1) {
        this.addToCardLoading = true;
        const drawer = document.querySelector('psn-cart-drawer');
        const sectionId = drawer?.dataset.sectionId || 'header';
        const formData = {
            items: [{ id: variantID, quantity: qty }],
            sections: sectionId,
        };
        fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(formData),
        })
            .then((response) => response.json())
            .then(async (data) => {
                if (!window.upcartSettings && data && !data.status) {
                    // /cart/add.js returns the line item (qty added), not the cart.
                    // Resolve item_count from the cart object every time.
                    const cartData = data.total_price
                        ? data
                        : await fetch('/cart.js').then((r) => r.json()).catch(() => null);
                    const itemCount = cartData?.item_count ?? 0;
                    const sectionHtml = data.sections?.[sectionId];
                    if (sectionHtml && drawer) {
                        document.dispatchEvent(
                            new CustomEvent('cart:update', {
                                bubbles: true,
                                detail: {
                                    cart: cartData,
                                    itemCount,
                                    sections: data.sections,
                                    source: 'product-card',
                                },
                            })
                        );
                    }
                    document.dispatchEvent(
                        new CustomEvent('cart:add', {
                            bubbles: true,
                            detail: { itemCount, cart: cartData },
                        })
                    );
                    document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
                } else if (!window.upcartSettings && data && !data.status) {
                    this.renderCartContents(data);
                }
                this.addToCardLoading = false;
            })
            .catch((error) => {
                console.error('Error:', error);
                this.addToCardLoading = false;
            });
    },
    renderCartContents(parsedState) {
        const cartDrawerEl = document.getElementById('CartDrawer');
        const cartIconBubbleEl = document.getElementById('cart-icon-bubble');
        if (cartDrawerEl && parsedState.sections?.['cart-drawer']) {
            cartDrawerEl.innerHTML = this.getSectionInnerHTML(parsedState.sections['cart-drawer'], '#CartDrawer');
        }
        if (cartIconBubbleEl && parsedState.sections?.['cart-icon-bubble']) {
            cartIconBubbleEl.innerHTML = this.getSectionInnerHTML(parsedState.sections['cart-icon-bubble'], '#cart-icon-bubble');
        }
        const oldDrawer = document.querySelector('cart-drawer.drawer');
        if (oldDrawer) {
            oldDrawer.classList.remove('is-empty');
            oldDrawer.classList.add('animate', 'active');
            oldDrawer.style.zIndex = '1000000';
            document.body.classList.add('overflow-hidden');
        }
    },
    // MIGRATED_FROM_OLD_CODE
    getSectionInnerHTML(html, selector = '.shopify-section') {
        return new DOMParser()
            .parseFromString(html, 'text/html')
            .querySelector(selector).innerHTML;
    },
    // MIGRATED_FROM_OLD_CODE
    backInStockSubmit(event) {
        let closestForm = event.target.closest('form');
        let emailInput = closestForm.querySelector('.product-card__notify-input');
        let emailValue = emailInput.value;
        let variant_id = closestForm.querySelector('.bis-variant-id').value;
        let shopify_variant_id = '$shopify:::$default:::' + variant_id;
        const bis_options = {
            method: 'POST',
            headers: {
                accept: 'application/json',
                revision: '2023-08-15',
                'content-type': 'application/json'
            },
            body: JSON.stringify({
                data: {
                    type: 'back-in-stock-subscription',
                    attributes: {
                        channels: ['EMAIL'],
                        profile: {
                            data: {
                                type: 'profile',
                                attributes: {
                                    email: emailValue,
                                }
                            },
                            email: emailValue,
                        }
                    },
                    relationships: {
                        variant: {
                            data: {
                                type: 'catalog-variant',
                                id: shopify_variant_id
                            }
                        }
                    }
                }
            })
        };

        fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=UhGMFT', bis_options)
            .then(response => {
                if(response.status === 202) {
                    closestForm.querySelector('.bis-success').classList.remove('ps-hidden');
                    emailInput.value = '';
                }
            })
            .catch(err => console.error(err));
    }
})
